import React, { useState } from 'react'
import { AllCategoryComponent } from '../Components/Category/AllCategoryComponent';
import { AllPeriodComponent } from '../Components/Period/AllPeriodComponent';
import { Button, Col, Row } from 'antd';
import { AddPeriodComponent } from '../Components/Period/AddPeriodComponent';
import { EditPeriodComponent } from '../Components/Period/EditPeriodComponent';
import { PeriodLimitation } from './PeriodLimitation';
import { SubPeriod } from './SubPeriod';
import { addButton } from '../assets/styles/stylesMain';
import { AllCategoryLayoutComponent } from '../Components/Category/AllCategoryLayoutComponent';
import { PeriodReservesComponent } from '../Components/Period/PeriodReservesComponent';
import { AReserveComponent } from '../Components/Reserve/AReserveComponent';
import { PeriodWonsComponent } from '../Components/Period/PeriodWonsComponent';
import { PeriodCategoryComponent } from '../Components/Category/PeriodCategoryComponent';
import { PeriodFoodsComponent } from '../Components/Period/PeriodFoodsComponent';
import { AReserveFoodsAndParking } from '../Components/FoodAndParkingReserve/AReserveFoodsAndParking';

// ======================================================================
export const Period = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('Category');
    const [categoryId, setCategoryId] = useState();
    const [categoryTitle, setCategoryTitle] = useState();
    const [version, setVersion] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [periodId, setPeriodId] = useState();
    const [periodTitle, setPeriodTitle] = useState();
    const [selectedReserveId, setSelectedReserveId] = useState();

    // ======================================================================
    return (
        <>
            {view == "Limitation" ?
                <PeriodLimitation
                    setLoading={setLoading}
                    showMessage={showMessage}
                    periodId={periodId}
                    periodTitle={periodTitle}
                    onBackClick={() => setView("All")}
                /> : <></>
            }
            {
                view == "SubPeriod" ?
                    <SubPeriod
                        setLoading={setLoading}
                        showMessage={showMessage}
                        periodId={periodId}
                        periodTitle={periodTitle}
                        periodCategoryId={categoryId}
                        onBackClick={() => setView("All")}

                    /> : <></>
            }
            {view === "Category" ?

                <PeriodCategoryComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    onClickItems={(id, title) => { setCategoryId(id); setCategoryTitle(title); setView("All"); }}
                />
                : <></>
            }
            {view === "All" ?
                <AllPeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    categoryId={categoryId}
                    categoryTitle={categoryTitle}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onAddClick={() => setView("Add")}
                    onBackClick={() => setView("Category")}
                    onEdit={(periodId) => { setPeriodId(periodId); setView("Edit") }}
                    onRowDeleted={() => { setVersion(version + 1); setView("All"); }}
                    onLimitationClick={(id, title) => { setPeriodId(id); setPeriodTitle(title); setView("Limitation") }}
                    onSubPeriodClick={(id, title) => { setPeriodId(id); setPeriodTitle(title); setView("SubPeriod") }}
                    onReservesClick={(id, title) => { setPeriodId(id); setPeriodTitle(title); setView("Reserves") }}
                    onFoodsClick={(id, title) => { setPeriodId(id); setPeriodTitle(title); setView("Foods") }}
                    onWonClick={(id, title) => { setPeriodId(id); setPeriodTitle(title); setView("Wons") }}
                    onLotteryClick={(id, title) => { setPeriodId(id); setPeriodTitle(title); setView("Lottery") }}
                /> : <></>
            }
            {view === "Edit" ?
                <EditPeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    rowUpdated={() => { setVersion(version + 1); setView("All"); }}
                    cancelEdit={() => { setView("All") }}

                    id={periodId}
                /> : <></>
            }
            {view === "Add" ?
                <AddPeriodComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    categoryId={categoryId}
                    rowInserted={() => { setVersion(version + 1); setView("All") }}
                    cancelInsert={() => setView("All")}
                /> : <></>
            }
            {view == "Reserves" ?
                <>
                    <PeriodReservesComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        periodId={periodId}
                        periodTitle={periodTitle}
                        onBackClick={() => setView("All")}
                        onItemClick={(id) => { setSelectedReserveId(id); setView("AReserve_Reserves") }}
                    />
                </> : <></>
            }
            {view == "Foods" ?
                <>
                    <PeriodFoodsComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        periodId={periodId}
                        periodTitle={periodTitle}
                        onBackClick={() => setView("All")}
                        onItemClick={(id) => { setSelectedReserveId(id); setView("AReserve_Foods") }}
                    />
                </> : <></>
            }
            {view == "Wons" ?
                <PeriodWonsComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    periodId={periodId}
                    periodTitle={periodTitle}
                    onBackClick={() => setView("All")}
                    onItemClick={(id) => { setSelectedReserveId(id); setView("AReserve_Won") }}
                /> : <></>
            }

            {view == "AReserve_Reserves" ?
                <AReserveComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    reserveId={selectedReserveId}
                    onBackClick={() => { setView('Reserves') }}
                /> : <></>
            }

            {view == "AReserve_Won" ?
                <AReserveComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    reserveId={selectedReserveId}
                    onBackClick={() => { setView('Wons') }}
                /> : <></>
            }

            {view == "AReserve_Foods" ?
                <AReserveFoodsAndParking
                    setLoading={setLoading}
                    showMessage={showMessage}
                    reserveId={selectedReserveId}
                    onBackClick={() => { setView('Foods') }}
                    onPayCompleted={() => { setView('Foods') }}
                /> : <></>
            }

            {view == "Lottery" ?
                <>
                    <PeriodReservesComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        periodId={periodId}
                        periodTitle={periodTitle}
                        onBackClick={() => setView("All")}
                        isShowLotteryButton={true}
                        onItemClick={(id) => { setSelectedReserveId(id); setView("AReserve_Reserves") }}
                    />
                </>
                : <></>
            }

        </>
    )
}